(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 750px)';
  var HINT_DELAY = 380;
  var HINT_DURATION = 2100;

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function getSlides(gallery) {
    var slides = [];
    for (var i = 0; i < gallery.children.length; i++) {
      var child = gallery.children[i];
      if (child.tagName === 'IMG' || child.classList.contains('iurop-product-card__placeholder')) {
        slides.push(child);
      }
    }
    return slides;
  }

  function setupCard(card) {
    var gallery = card.querySelector('[data-product-card-gallery]');
    if (!gallery) return;
    var slides = getSlides(gallery);
    if (slides.length < 2) return;

    var dots = card.querySelectorAll('[data-product-card-dots] .iurop-product-card__dot');
    if (!dots.length) return;

    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
          var idx = slides.indexOf(entry.target);
          if (idx >= 0) {
            for (var j = 0; j < dots.length; j++) {
              dots[j].classList.toggle('is-active', j === idx);
            }
          }
        }
      }
    }, { root: gallery, threshold: [0.55] });

    slides.forEach(function (slide) { observer.observe(slide); });
  }

  function playHint(card) {
    if (card.dataset.swipeHinted === '1') return;
    card.dataset.swipeHinted = '1';
    card.classList.add('is-swipe-hinting');
    window.setTimeout(function () {
      card.classList.remove('is-swipe-hinting');
    }, HINT_DURATION);
  }

  var GRID_SELECTOR = [
    '.iurop-product-list__grid',
    '.iurop-collection__grid',
    '.iurop-coll-grid__grid',
    '[data-collection-grid]',
    '[data-product-recommendations-grid]'
  ].join(', ');

  function scheduleHints() {
    if (!isMobile()) return;

    var grids = document.querySelectorAll(GRID_SELECTOR);
    grids.forEach(function (grid) {
      if (grid.dataset.swipeHintWired === '1') return;
      grid.dataset.swipeHintWired = '1';

      var firstCard = grid.querySelector('[data-product-card]');
      if (!firstCard) return;

      var gallery = firstCard.querySelector('[data-product-card-gallery]');
      if (!gallery) return;
      if (getSlides(gallery).length < 2) return;

      var io = new IntersectionObserver(function (entries, obs) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            window.setTimeout(function () { playHint(firstCard); }, HINT_DELAY);
            obs.disconnect();
            break;
          }
        }
      }, { threshold: 0.45 });
      io.observe(firstCard);
    });
  }

  function init() {
    var cards = document.querySelectorAll('[data-product-card]');
    cards.forEach(setupCard);
    scheduleHints();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when sections are re-rendered (theme editor + dynamic loads)
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('iurop:product-list:rendered', init);
})();
